import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { ResultTable } from "../../types/types";
// import { createTheme, ThemeProvider } from "@mui/material/styles";

const CustomizedTable: React.FC<{
  jsonResult: ResultTable[];
  StyledTableCell: React.ElementType;
}> = ({ jsonResult, StyledTableCell }) => {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell style={{ width: "25%", fontSize: "1.5rem" }}>
              Dimension
            </StyledTableCell>
            <StyledTableCell
              align="center"
              style={{ width: "15%", fontSize: "1.5rem" }}
            >
              Result
            </StyledTableCell>
            <StyledTableCell
              align="center"
              style={{ width: "20%", fontSize: "1.5rem" }}
            >
              Level
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {jsonResult &&
            jsonResult.map((row) => (
              <TableRow key={row.dimension}>
                <StyledTableCell style={{}} component="th" scope="row">
                  {row.dimension}
                </StyledTableCell>
                <StyledTableCell style={{}} align="center">
                  {row.percentage}%
                </StyledTableCell>
                <StyledTableCell style={{}} align="center">
                  {row.level}
                </StyledTableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CustomizedTable;
